'use client'

import { forwardRef, ReactNode } from 'react'

import { Input, InputProps } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface Props extends InputProps {
  icon?: ReactNode
  iconContainerClassName?: string
}

const InputWithIcon = forwardRef<HTMLInputElement, Props>(
  ({ icon, inputClassName, iconContainerClassName, className, ...props }, ref) => {
    return (
      <div
        className={cn([
          'group group-focus:border-foreground/20 border-foreground/15 relative mb-2 flex items-center justify-between border bg-transparent transition-colors group-focus:border',
          className,
        ])}
      >
        <Input
          className={cn(['h-8 w-full', inputClassName])}
          inputClassName="h-8 px-2 py-[7.5px] md:text-xs md:text-[10px] text-xs text-[10px] bg-transparent"
          placeholder="Code"
          {...props}
          ref={ref}
        />
        <div
          className={cn([
            'mr-5 flex size-4 items-center justify-center text-end font-semibold tracking-tight whitespace-nowrap text-white',
            iconContainerClassName,
          ])}
        >
          {icon}
        </div>
      </div>
    )
  }
)

InputWithIcon.displayName = 'InputWithIcon'

export default InputWithIcon
